// @flow

import $ from 'jquery';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import pdfjsWorker from 'pdfjs-dist/legacy/build/pdf.worker.entry';
import JQueryView from './JQueryView';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default class PdfPreviewerV2 extends JQueryView {
  constructor() {
    super('.pdf-previewer-v2-pages');

    if (this.$el.hasClass('previewed')) return;
    this.$el.addClass('previewed');

    this.$el.each((_, previewer) => {
      const $previewer = $(previewer);
      const url = $previewer.data('pdf-url');
      const cMapUrl = $previewer.data('cmap-url') || null;
      const showLoading = $previewer.data('show-loading');

      pdfjsLib
        .getDocument({ url, cMapUrl })
        .promise.then(pdfDocument => {
          this.renderPages($previewer, pdfDocument).then(() => {
            if (showLoading) {
              const spinner = $previewer.closest('.pdf-previewer-wrapper')[0]
                .children[0];
              spinner.classList.add('d-none');

              const scrollWrapper = $previewer.closest(
                '.pdf-previewer-v2-scroll-wrapper',
              )[0];
              scrollWrapper.classList.remove('d-none');

              const pdfViewer = $previewer.closest('.pdf-previewer-v2')[0];
              pdfViewer.classList.remove('d-none');

              // 複数ローディングが表示されている場合、最後のローディングが非表示になったタイミングで非活性のボタンを活性化する
              const spinnerDisabledLinks = Array.from(
                document.getElementsByClassName('disabled-during-loading'),
              );
              const spinners = document.querySelectorAll(
                '.spinner:not(.d-none)',
              );
              if (spinnerDisabledLinks.length !== 0 && spinners.length === 0) {
                spinnerDisabledLinks.forEach(el => {
                  el.classList.remove('disabled-during-loading');
                  el.classList.add('loading_completion');
                });
              }
            }
          });
        })
        .catch(reason => {
          console.error('Error: ' + reason);
        });
    });
  }

  renderPages($previewer: any, pdfDocument: pdfjsLib.PDFDocumentProxy) {
    for (let i = 0; i < pdfDocument.numPages; i++)
      $previewer.append('<canvas class="pdf-page" />');

    const promises = $previewer.children().map((index, canvas) => {
      const pageNum = index + 1;
      return pdfDocument.getPage(pageNum).then(pdfPage => {
        // 2倍の解像度で描画してモバイルアクセス時などの拡大に耐えられるようにする
        const scale = 2;
        const viewport = pdfPage.getViewport({ scale });

        canvas.width = viewport.width;
        canvas.height = viewport.height;
        canvas.style.width = '100%';
        canvas.style.height = '100%';

        const ctx = canvas.getContext('2d');
        const renderTask = pdfPage.render({
          canvasContext: ctx,
          viewport,
        });
        return renderTask.promise;
      });
    });

    return Promise.all(promises);
  }
}
